import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { getToken } from '../../../../helpers/Jwt';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faClose, faSign, faSignHanging, faSignIn, faSignLanguage, faSignature, faSigning } from '@fortawesome/free-solid-svg-icons';
import ModalSign from '../../component/ModalSign/ModalSign';
import BadgeStatus from '../../component/BadgeStatus/BadgeStatus';
import { faSave } from '@fortawesome/free-regular-svg-icons';

const DetailFileReception = () => {
    const { id } = useParams();

    const [error, setError] = useState(null);

    const [detailData, setDetailData] = useState(null);
    const [isModalSign, setModalSign] = useState(false);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_FILE_RECEPTION = "api/kejati/dashboard/FileReception";

    const fetchData = async (url, headers) => {
        try {
            const response = await axios.get(url, { headers });
            return response.data;
        } catch (err) {
            setError("Gagal memuat data. Silakan coba lagi.");
            console.error(err);
            return null;
        }
    };

    const handleSign = async () => {
        setModalSign(true);
    }

    useEffect(() => {
        if (id) {
            fetchData(`${BASE_URL}${PATH_FILE_RECEPTION}/detail?id=${id}`, {
                Authorization: `Bearer ${getToken()}`,
                "Content-Type": "application/json"
            }).then((detail) => {
                setDetailData(detail);
            });
        }
    }, [id]);

    const statusColor = (status) => {
        switch (status) {
            case 'pending':
                return 'info';
            case 'approved':
                return 'warning';
            case 'canceled':
                return 'error';
            case 'sign':
                return 'default';
            case 'default':
                break;
        }
        return 'default';
    }

    const statusText = (status) => {
        switch (status) {
            case 'pending':
                return "Menunggu";
            case 'saved':
                return "Disimpan";
            case 'signed':
                return 'Sudah Diserahkan';
            case 'default':
                break;
        }
        return status;
    }

    return (
        <div className="font-sans p-6 min-h-screen">
            <ModalSign
                show={isModalSign}
                onClose={() => setModalSign(false)}
                signedName1={"Yang Mengirim"}
                signedName2={"Operator PTSP"}
                onChange={async (value) => {
                    try {
                        const response = await axios({
                            method: "POST",
                            url: `${BASE_URL}${PATH_FILE_RECEPTION}/sign`,
                            data: {
                                id,
                                image_signature_given: value.x,
                                image_signature_received: value.y
                            },
                            headers: {
                                Authorization: `Bearer ${getToken()}`,
                                "Content-Type": "application/json"
                            }
                        });

                        const { message } = response.data;

                        alert(message);
                        window.location.reload();
                    } catch (error) {
                        alert(error)
                    }
                }} />
            <div className='flex justify-between'>
                <h1 className="text-2xl font-bold text-gray-800 mb-6">Data Detail</h1>
            </div>
            <div className='p-3 rounded-lg shadow-md bg-white'>
                <div className='flex justify-between'>
                    <div className="px-3">                        
                    </div>
                    <div>
                        <BadgeStatus text={statusText(detailData?.status)} status={() => statusColor(detailData?.status)} />
                    </div>
                </div>
                <div className='px-3'>
                    {detailData?.status != 'signed' ? <>
                        <button onClick={handleSign} type='button' className='text-white text-xs rounded focus:ring bg-yellow-500 hover:bg-yellow-700 p-2 mx-1'>
                            <FontAwesomeIcon icon={faSignature} color="white" /> Tanda Terima Berkas
                        </button>                        
                    </> : <></>}
                </div>
                <hr className='my-5' />
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="px-3">
                        <strong className="block text-gray-600">Jenis Berkas</strong>
                        <p className="text-gray-800">{detailData?.type}</p>
                    </div>
                    <div className="px-3">
                        <strong className="block text-gray-600">Nomor Berkas</strong>
                        <p className="text-gray-800">{detailData?.number}</p>
                    </div>
                    <div className="px-3">
                        <strong className="block text-gray-600">Pengirim</strong>
                        <p className="text-gray-800">{detailData?.sender}</p>
                    </div>
                    <div className="px-3">
                        <strong className="block text-gray-600">No. HP Pengirim</strong>
                        <p className="text-gray-800">{detailData?.phone_sender}</p>
                    </div>
                    <div className="px-3">
                        <strong className="block text-gray-600">Penerima</strong>
                        <p className="text-gray-800">{detailData?.receiver}</p>
                    </div>
                    <div className="px-3">
                        <strong className="block text-gray-600">No. HP Penerima</strong>
                        <p className="text-gray-800">{detailData?.phone_receiver}</p>
                    </div>
                    <div className="px-3">
                        <strong className="block text-gray-600">Waktu Diterima</strong>
                        <p className="text-gray-800">{detailData?.date} {detailData?.time}</p>
                    </div>
                </div>

                <hr className='my-5' />

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div className="px-3">
                        <strong className="block text-gray-600">Pengirim</strong>
                        <div className='border-2 border-gray-300 rounded-xl shadow-sm overflow-hidden'>
                            <img className="object-cover  max-w-48 h-auto mt-2" src={`${BASE_URL}/upload/${detailData?.image_signature_given}`} alt="Signature" />

                        </div>
                    </div>
                    <div className="px-3">
                        <strong className="block text-gray-600">Operator PTSP</strong>
                        <div className='border-2 border-gray-300 rounded-xl shadow-sm overflow-hidden'>
                            <img className="object-cover max-w-48 h-auto mt-2" src={`${BASE_URL}/upload/${detailData?.image_signature_received}`} alt="Signature" />

                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default DetailFileReception;